(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/init.js');

'use strict';

const logger = svs.core.log.getLogger('component:youtube-video_init');
const {
  trackEvent
} = svs.components.analytics;

svs.components.youtube_video.init = function (options) {
  if (!options.videoId) {
    logger.error('Missing videoId');
    return;
  }
  if (options && options.selector && options.src) {
    const videoHtml = svs.components.youtube_video.templates.youtube_video(options);
    $(options.selector).append(videoHtml);
  } else {
    logger.error('Error in options object', options);
  }
};
let isIframeHovered = false;
let currentIframe = null;

function handleBlur() {
  if (isIframeHovered && currentIframe) {
    const videoLabel = currentIframe.getAttribute('data-tracking-label') || '';
    trackEvent({
      action: 'interaction',
      category: 'Video',
      opt_label: "YouTube - ".concat(videoLabel),
      opt_value: 1
    });
  }
}

function handleInteractionEvents(event) {
  if (event.type === 'mouseover' || event.type === 'touchstart') {
    isIframeHovered = true;
    currentIframe = event.currentTarget; 
  } else if (event.type === 'mouseout' || event.type === 'touchend') {
    isIframeHovered = false;
    currentIframe = null; 
    window.focus();
  }
}
const iframes = document.querySelectorAll('.js-youtube-video-iframe');
iframes.forEach(iframe => {
  iframe.addEventListener('mouseover', handleInteractionEvents);
  iframe.addEventListener('mouseout', handleInteractionEvents);
  iframe.addEventListener('touchstart', handleInteractionEvents);
  iframe.addEventListener('touchend', handleInteractionEvents);
});
window.addEventListener('blur', handleBlur);

 })(window);